import { render, staticRenderFns } from "./ItsBasePort.vue?vue&type=template&id=dd7d93cc&scoped=true&"
import script from "./ItsBasePort.vue?vue&type=script&lang=js&"
export * from "./ItsBasePort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7d93cc",
  null
  
)

export default component.exports